<template>
    <div>
        <div class="d-flex flex-column align-items-center">
            <h5 class="text-center primary-color">
                Your password has been reset
            </h5>
            <BaseIcon
                class="primary-color my-2"
                name="check-circle"
                size="4x"
            />
            <div class="mt-5">
                <BaseButton variant="primary" @click="goToHome"
                    >Back to main page</BaseButton
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SuccessModule',
    methods: {
        goToHome() {
            this.$router.push(this.$URLS.findjobs);
        },
    },
};
</script>

<style scoped></style>
